import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PartieDepot } from '../../../../../entities/requete';


@Component({
    selector: 'jhi-added-requerant',
    templateUrl: './added-requerant.component.html',
    styleUrls: [
        'added-requerant.component.scss'
    ]
})
export class AddedRequerantComponent {

    @Input()
    requerants: Array<PartieDepot>;

    @Output() onRemoveRequerant = new EventEmitter<any>();
    @Output() onMoveToPrincipal = new EventEmitter<any>();

    removeRequerant(requerant: PartieDepot) {
        const index = this.requerants.indexOf(requerant);
        this.onRemoveRequerant.emit(index);
    }

    constructor() {
    }

    moveToRequerantPricipal(requerant: PartieDepot) {
        const index = this.requerants.indexOf(requerant);
        this.onMoveToPrincipal.emit(index);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/requerants/add-requerant-section/added-requerant/added-requerant.component.ts